// extracted by mini-css-extract-plugin
export default {"title":"T_-z","warning":"U_-z","sizeOptionsLegendText":"V_-z"};